import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/uptime/configProbe/list/uptime.configProbe.list.query.gql"
import type {
  UptimeConfigProbeListQuery,
  UptimeConfigProbeListQueryVariables,
} from "@/v2-backoffice-client/uptime/configProbe/list/__types__/uptime.configProbe.list.query"

type Options = QueryHookOptions<
  UptimeConfigProbeListQuery,
  UptimeConfigProbeListQueryVariables
>

// useUptimeConfigProbeListQuery powers the Probes tab in the
// Configuration sheet. Pages through `getUptimeProbesList` -- the
// same paginated table conventions every other backoffice list
// uses (CustomerTable, UptimeIncidentTable, etc).
export function useUptimeConfigProbeListQuery(options?: Options) {
  return useQuery<
    UptimeConfigProbeListQuery,
    UptimeConfigProbeListQueryVariables
  >(query, options)
}
